<template>
  <span>{{ output }}</span>
</template>

<script setup>
/**
 * @typedef {Object} DateCellParams
 * @param {String} value
 */
const props = defineProps({
  /** @type {DateCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const output = (() => {
  return props.params.value ? props.params.value.toFixed(1) + '%' : ''
})()
</script>
